import { useLocalStorage } from 'ui/Hooks';

// Utilizing a singular hook for this to avoid the need to pass around the local storage keys
const useEmailStorage = () => {
  const [localStorageEmail, setLocalStorageEmail, removeLocalStorageEmail] = useLocalStorage<
    string | undefined
  >({
    key: 'x-onboarding-extension',

    getInitialValueInEffect: false,
  });

  return {
    localStorageEmail,
    setLocalStorageEmail,
    removeLocalStorageEmail,
  };
};

export { useEmailStorage };
